export default __webpack_public_path__ + "static/media/checkbox-bird-white.f0448ed9.svg";